import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import ReceiptIcon from '@material-ui/icons/Receipt';
import TokenIcon from "@material-ui/icons/VpnKey";
import SecretIcon from "@material-ui/icons/Lock";
import KeyIcon from "@material-ui/icons/Security";
import PhoneInTalkIcon from "@material-ui/icons/PhoneInTalk";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import AccountBalanceWalletRoundedIcon from "@material-ui/icons/AccountBalanceWalletRounded";
import Avatar from "@material-ui/core/Avatar";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 450,
    // backgroundColor: "#EEEEEE",
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
}));

export default function ProfileDetail({ profiles }) {
  const classes = useStyles();

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "solid 1px #dddddd",
          paddingBottom: "20px",
        }}
      >
        <Avatar
          alt={profiles?.businessName ? profiles.businessName : profiles.name}
          src={profiles?.logo}
          className={classes.large}
        />
      </div>
      <List className={classes.root}>
        <ListItem>
          <BusinessCenterIcon style={{ marginRight: "20px", color: "gray" }} />
          <ListItemText primary="Company Name" secondary={profiles?.businessName} />
        </ListItem>
        <ListItem>
          <ReceiptIcon 
            style={{ marginRight: "20px", color: "gray", height: "50px" }}
          />
          <ListItemText primary="GST Number" secondary={profiles?.gstno}/>
        </ListItem>
        <ListItem>
          <TokenIcon
            style={{ marginRight: "20px", color: "gray", height: "50px" }}
          />
          <ListItemText primary="Whatsapp API token" secondary={profiles?.token} />
        </ListItem>
        <ListItem>
          <KeyIcon
            style={{ marginRight: "20px", color: "gray", height: "50px" }}
          />
          <ListItemText primary="Razorpay Key" secondary={profiles?.razorpayKey} />
        </ListItem>
        <ListItem>
          <SecretIcon
            style={{ marginRight: "20px", color: "gray", height: "50px" }}
          />
          <ListItemText primary="Razorpay Secret" secondary={profiles?.razorpaySecret} />
        </ListItem>

        <ListItem>
          <LocationOnIcon style={{ marginRight: "20px", color: "gray" }} />
          <ListItemText primary="Address" secondary={profiles?.contactAddress} />
        </ListItem>

        <ListItem>
          <PhoneInTalkIcon style={{ marginRight: "20px", color: "gray" }} />
          <ListItemText primary="Phone Number" secondary={profiles?.phoneNumber} />
        </ListItem>

        <ListItem>
          <AlternateEmailIcon style={{ marginRight: "20px", color: "gray" }} />
          <ListItemText primary="Email Address" secondary={profiles?.email} />
        </ListItem>

        <ListItem>
          <AccountBalanceWalletRoundedIcon
            style={{ marginRight: "20px", color: "gray" }}
          />
          <ListItemText primary="Note | Payment Info" secondary={profiles?.paymentDetails} />
        </ListItem>
      </List>
    </>
  );
}
